module.exports = __webpack_public_path__ + "static/media/Sample_Files.daf627c3.svg";